<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
      <el-button type="primary" @click="add"
        ><i class="el-icon-plus"></i>新增</el-button
      >
      <el-button type="primary" @click="handleExport"
        ><i class="el-icon-download"></i> 导出</el-button
      >
      <BaseTable
        ref="baseTable"
        url="/admin/correct/index"
        :tableData.sync="tableData"
        :columns="columns"
        :paramsCepCallback="paramsCepCallback"
      >
        <template #handle="{ row }">
          <el-button type="text" size="mini" @click="detail(row)"
            >详情</el-button
          >
          <el-button
            v-if="row.status === 0"
            type="text"
            size="mini"
            @click="del(row)"
            >删除</el-button
          >
          <el-button
            v-if="row.status === 0"
            type="text"
            size="mini"
            @click="audit(row)"
            >审核</el-button
          >
          <el-button
            v-if="row.status === 1"
            type="text"
            size="mini"
            @click="edit(row)"
            >编辑</el-button
          >
          <el-button
            v-if="row.status === 2"
            type="text"
            size="mini"
            @click="comfrim(row)"
            >财务确认</el-button
          >
        </template>
      </BaseTable>
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="30%"
        @close="dialogClosed"
      >
        <BaseForm
          v-if="dialogFlag === 'audit'"
          ref="baseForm"
          v-model="formData"
          :formOptions="auditFormOption"
          :rules="rules"
        ></BaseForm>
        <BaseForm
          v-if="dialogFlag !== 'audit'"
          ref="baseForm"
          v-model="formData"
          :formOptions="cashFormOption"
          :rules="rules"
          labelWidth="120px"
          @formChange="formChange"
        >
          <el-form-item
            v-if="findItem('微信收款码')"
            prop="wx_qrcode_amount"
            label="微信收款码(元)"
          >
            <el-input
              v-model="formData.wx_qrcode_amount"
              @change="formChange"
              placeholder="元"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="findItem('公户收款码')"
            prop="gh_qrcode_amount"
            label="公户收款码(元)"
          >
            <el-input
              v-model="formData.gh_qrcode_amount"
              placeholder="元"
              @change="formChange"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="findItem('公户')"
            prop="gh_amount"
            label="公户(元)"
          >
            <el-input
              v-model="formData.gh_amount"
              placeholder="元"
              @change="formChange"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="findItem('其他')"
            prop="other_amount"
            label="其他(元)"
          >
            <el-input
              v-model="formData.other_amount"
              placeholder="元"
              @change="formChange"
            ></el-input>
          </el-form-item>
          <el-form-item label="实收金额(元)" prop="realInFee">
            <el-input
              v-model="formData.realInFee"
              disabled
              placeholder="元"
            ></el-input>
          </el-form-item>
          <el-form-item label="交费时间" prop="payTime">
            <el-date-picker
              type="datetime"
              v-model="formData.payTime"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
        </BaseForm>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button size="small" type="primary" @click="handleSubmit"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  searchFormOption,
  auditFormOption,
  cashFormOption,
} from "./formOptions";
import { rules } from "./rules";
import { columns } from "./columns";

export default {
  name: "Privy",
  comments: {},
  data() {
    return {
      searchData: {},
      tableData: [],
      orgOption: [],
      // 弹框相关
      dialogTitle: "",
      dialogVisible: false,
      dialogFlag: "",
      // 表单相关
      formData: {
        inType: [],
        wx_qrcode_amount: 0,
        gh_qrcode_amount: 0,
        gh_amount: 0,
        other_amount: 0,
      },
      rules: rules(this),
    };
  },
  computed: {
    columns,
    searchFormOption,
    auditFormOption,
    cashFormOption,
  },
  created() {},
  methods: {
    add() {
      this.$router.push({
        path: "/correct/endorsement/recording",
		query: {
			isShowBtn: 1,
		}
      });
    },
    edit(row) {
      this.$router.push({
        path: "/correct/endorsement/recording",
        query: {
          correctId: row.id,
		  isShowBtn: 1,
        },
      });
    },
    detail(row) {
      this.$router.push({
        path: "/correct/endorsement/recording",
        query: {
          correctId: row.id,
		  isShowBtn: 0,
        },
      });
      // this.$router.push({
      //   path: "/issue/detail",
      //   query: {
      //     correctId: row.id,
      //   },
      // });
    },
    async handleExport() {
      const res = await this.$api.post(
        "/admin/correct/exportExcel",
        this.searchData,
        "导出"
      );
      console.log(res);
      window.open("https://" + res.data);
    },
    del({ id }) {
      this.$confirm("是否确认删除该批单信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.$api.post("/admin/correct/del", { id }, "删除").then(() => {
            this.$refs.baseTable.searchData();
          });
          this.handleSearch();
        })
        .catch(() => {
          this.$message({
            type: "formData",
            message: "已取消操作",
          });
        });
    },
    // 审批
    audit(row) {
      this.dialogFlag = "audit";
      this.dialogTitle = `批单审核(${row.insBillId})`;
      this.dialogVisible = true;
      this.formData = {
        ...this.formData,
        ...row,
        correctId: row.insBillId,
        res: 1,
      };
    },
    // 财富确认
    comfrim(row) {
      this.dialogTitle = `批单审核(${row.insBillId})`;
      this.dialogFlag = "confrim";
      this.dialogVisible = true;
      this.formData = {
        ...this.formData,
        ...row,
        payTime: this.$moment().format(),
      };
    },
    // 点击搜索
    handleSearch() {
      console.log(this.searchData);
      this.$refs.baseTable.searchData(1);
    },
    findItem(key) {
      return this.formData.inType.find((item) => item === key);
    },
    formChange(val, prop) {
      console.log(val);
      if (prop === "inType") {
        if (!this.findItem("微信收款码")) {
          this.formData = {
            ...this.formData,
            wx_qrcode_amount: 0,
          };
        }
        if (!this.findItem("公户收款码")) {
          this.formData = {
            ...this.formData,
            gh_qrcode_amount: 0,
          };
        }
        if (!this.findItem("公户")) {
          this.formData = {
            ...this.formData,
            gh_amount: 0,
          };
        }
        if (!this.findItem("其他")) {
          this.formData = {
            ...this.formData,
            other_amount: 0,
          };
        }
      }
      this.formData = {
        ...this.formData,
        realInFee:
          this.formData.wx_qrcode_amount * 1 +
          this.formData.gh_qrcode_amount * 1 +
          this.formData.gh_amount * 1 +
          this.formData.other_amount * 1,
      };
    },
    // 提交
    handleSubmit() {
      console.log(this.formData);
      this.$refs.baseForm.onSubmit((validate) => {
        if (validate) {
          console.log(this.formData);
          this.$confirm("是否确认提交, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(async () => {
              let url = "";
              let msg = "";
              let params = {};
              if (this.dialogFlag === "audit") {
                url = "/admin/correct/audit";
                msg = "审核";
                params = {
                  ...this.formData,
                };
              } else {
                url = "/admin/correct/financeExamine";
                msg = "财务确认";
                params = {
                  ...this.formData,
                };
              }
              await this.$api.post(url, params, msg);
              this.dialogVisible = false;
              this.handleSearch();
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消操作",
              });
            });
        }
      });
    },
    // 弹框关闭
    dialogClosed() {
      this.formData = {
        inType: [],
        wx_qrcode_amount: 0,
        gh_qrcode_amount: 0,
        gh_amount: 0,
        other_amount: 0,
      };
      this.$refs.baseForm.resetFields();
    },
    // 搜索参数拦截
    paramsCepCallback(params) {
      console.log(params);
      return {
        ...params,
        ...this.searchData,
      };
    },
  },
};
</script>
